import { render, staticRenderFns } from "./AppPageLoader.vue?vue&type=template&id=02242211&scoped=true"
import script from "./AppPageLoader.vue?vue&type=script&lang=js"
export * from "./AppPageLoader.vue?vue&type=script&lang=js"
import style0 from "./AppPageLoader.vue?vue&type=style&index=0&id=02242211&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02242211",
  null
  
)

export default component.exports